var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('k-button',_vm._g(_vm._b({staticClass:"btn rounded-0",on:{"click":_vm.onClick}},'k-button',_vm.$props,false),_vm.listeners),[_vm._v(" buttons.delete ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }